import { render, staticRenderFns } from "./BoldIcon.vue?vue&type=template&id=b0328ade"
import script from "./BoldIcon.vue?vue&type=script&lang=js"
export * from "./BoldIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports